/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Intro_TitleInputs */

const es_privacy_policy_intro_title = /** @type {(inputs: Privacy_Policy_Intro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Introduccion`)
};

const en_privacy_policy_intro_title = /** @type {(inputs: Privacy_Policy_Intro_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Introduction`)
};

/**
* | output |
* | --- |
* | "1. Introduction" |
*
* @param {Privacy_Policy_Intro_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_intro_title = /** @type {((inputs?: Privacy_Policy_Intro_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Intro_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_intro_title(inputs)
	return en_privacy_policy_intro_title(inputs)
});
export { privacy_policy_intro_title as "privacy_policy.intro.title" }